import React, { useState } from "react";
import ModalWithTopBar from "~/shared/ModalWithTopBar";
import Button from "~/shared/Btn";
import MaskedInput from "~/shared/MaskedInput";
import { removeNonNumericalCharacters } from "~/utils/phone";

type MissingFieldsModalProps = {
    isOpen: boolean;
    onSave: (data: { phone: string }) => void;
};

const MissingFieldsModal = ({ isOpen, onSave }: MissingFieldsModalProps) => {
    const [phone, setPhone] = useState("");
    const [errors, setErrors] = useState("");
    const [loading, setLoading] = useState(false);

    const savePhone = () => {
        if (!phone) {
            setErrors("Telefone é um campo obrigatório");
            return;
        }

        setLoading(true);
        onSave({ phone: `+55${removeNonNumericalCharacters(phone)}` });
    };

    const onHide = () => {};

    return (
        <ModalWithTopBar isOpen={isOpen} onHide={onHide} blockModal>
            <div className="content">
                <h2>Complete seu cadastro para solicitar o job</h2>
                <br />
                <div>
                    <p>Precisamos do seu telefone para entrarmos em contato sobre mudanças em seu job.</p>
                    <MaskedInput
                        name="phone"
                        placeholder="Telefone"
                        value={phone}
                        onChange={(_, value) => setPhone(value)}
                        error={errors}
                        mask={[
                            "(",
                            /\d/,
                            /\d/,
                            ")",
                            " ",
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                            "-",
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                        ]}
                    />
                    <Button block variant="success" onClick={savePhone} loading={loading}>
                        Salvar
                    </Button>
                </div>
            </div>
        </ModalWithTopBar>
    );
};

export default MissingFieldsModal;
